import { useState, useCallback } from "react";
const useConversationState = () => {
  const [conversationId, setConversationId] = useState(() => {
    const params = new URLSearchParams(window.location.search);
    return params.get("conversationId") || null;
  });
  const [followUpQuestions, setFollowUpQuestions] = useState([]);
  const [conversationHistory, setConversationHistory] = useState([]);
  const [isActivelyStreaming, setIsActivelyStreaming] = useState(false);
  const [streamingAIResponse, setStreamingAIResponse] = useState("");
  const [currentStatus, setCurrentStatus] = useState("");
  const [previewSearchQueries, setPreviewSearchQueries] = useState([]);
  const [searchAngleDetails, setSearchAngleDetails] = useState({});
  const [previewQueryProducts, setPreviewQueryProducts] = useState([]);
  const [isWaitingForFollowUpQueries, setIsWaitingForFollowUpQueries] = useState(false);
  const [productMetadataMap, setProductMetadataMap] = useState(/* @__PURE__ */ new Map());
  const [surveyMetadataMap, setSurveyMetadataMap] = useState(/* @__PURE__ */ new Map());
  const [streamingProductGroups, setStreamingProductGroups] = useState(/* @__PURE__ */ new Map());
  const [streamingFeaturedProduct, setStreamingFeaturedProduct] = useState(null);
  const [streamingStoreLocator, setStreamingStoreLocator] = useState(null);
  const [streamingLoginRequired, setStreamingLoginRequired] = useState(null);
  const [streamingDevInfo, setStreamingDevInfo] = useState(null);
  const [conversationPageContext, setConversationPageContext] = useState(null);
  const [isSharedView, setIsSharedView] = useState(false);
  const [sharedByUserName, setSharedByUserName] = useState(void 0);
  const [sharedAtMessageIndex, setSharedAtMessageIndex] = useState(void 0);
  const [sourceConversationId, setSourceConversationId] = useState(void 0);
  const [sourceCheckpointIndex, setSourceCheckpointIndex] = useState(void 0);
  const clearStreamingState = useCallback(() => {
    setStreamingAIResponse("");
    setPreviewSearchQueries([]);
    setPreviewQueryProducts([]);
    setCurrentStatus("");
    setStreamingFeaturedProduct(null);
    setStreamingStoreLocator(null);
    setStreamingLoginRequired(null);
    setStreamingDevInfo(null);
  }, []);
  return {
    conversationId,
    setConversationId,
    conversationHistory,
    setConversationHistory,
    isActivelyStreaming,
    setIsActivelyStreaming,
    streamingAIResponse,
    setStreamingAIResponse,
    currentStatus,
    setCurrentStatus,
    previewSearchQueries,
    setPreviewSearchQueries,
    searchAngleDetails,
    setSearchAngleDetails,
    previewQueryProducts,
    setPreviewQueryProducts,
    isWaitingForFollowUpQueries,
    setIsWaitingForFollowUpQueries,
    productMetadataMap,
    setProductMetadataMap,
    surveyMetadataMap,
    setSurveyMetadataMap,
    streamingProductGroups,
    setStreamingProductGroups,
    followUpQuestions,
    setFollowUpQuestions,
    streamingFeaturedProduct,
    setStreamingFeaturedProduct,
    streamingStoreLocator,
    setStreamingStoreLocator,
    streamingLoginRequired,
    setStreamingLoginRequired,
    streamingDevInfo,
    setStreamingDevInfo,
    clearStreamingState,
    conversationPageContext,
    setConversationPageContext,
    // Sharing state
    isSharedView,
    setIsSharedView,
    sharedByUserName,
    setSharedByUserName,
    sharedAtMessageIndex,
    setSharedAtMessageIndex,
    sourceConversationId,
    setSourceConversationId,
    sourceCheckpointIndex,
    setSourceCheckpointIndex
  };
};
export {
  useConversationState
};
//# sourceMappingURL=useConversationState.js.map
